import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

import { SummaryTagsComponent } from './summary-tags.component';

const MODULES = [
  CommonModule,
  MatRippleModule,
  MatIconModule
];

const COMPONENTS = [
  SummaryTagsComponent
];

@NgModule({
  imports: [
    MODULES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    SummaryTagsComponent
  ]
})
export class SummaryTagsModule { }
